module.exports = __webpack_public_path__ + "img/teeth-11.9b126407.png";